<div class="main-box no-border large-graph" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="inner-body">
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <div class="card grap-card increase no-border">
          <div class="card-body p-0">
            <div class="graph-up d-flex align-items-center justify-content-between">
              <div class="graph-text">
                <h4>{{ t('charts.fuelCostRandsPerLitre') }}</h4>
                <p>
                  {{ headline.value }} <strong>{{ headline.change }}</strong>
                  <i><img src="./assets/images-fuel/upgreen-icon.svg" alt="down-icon" /></i>
                </p>
              </div>
              <div class="button-wrapper">
                <div class="datelisting common-filter common-dropdown-checkbox">
                  <div class="common-drop-down dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-menu"
                      data-bs-toggle="dropdown" aria-expanded="false">
                      {{ t('filters.filterByLocation') }}
                      <img src="assets/images-fuel/filterDrpDwnIcon.svg" alt="">
                    </button>

                    <ul class="dropdown-menu large-menu dropdown-menu-end checkbox-wrapper"
                      aria-labelledby="dropdown-menu" (click)="buttonMenuClick($event)">
                      <li>
                        <div class="dropdown-search drop-down-search">
                          <img src="assets/images-fuel/searchIcon.svg" alt="search-icon" />
                          <input type="text" [placeholder]="t('filters.searchAccounts')" />
                        </div>
                      </li>
                      <li>
                        <div>
                          <label class="parent-check-box">
                            <input type="checkbox" id="parent-task" />
                            <span>{{ t('locations.southAfrica') }}</span>
                          </label>
                          <div class="task-group">
                            <label>
                              <input type="checkbox" id="child-task-1" />
                              <span>{{ t('locations.johannesburg') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-2" />
                              <span>{{ t('locations.polokwane') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-3" />
                              <span>{{ t('locations.gqeberha') }}</span>
                            </label>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div>
                          <label class="parent-check-box">
                            <input type="checkbox" id="parent-task" />
                            <span>{{ t('locations.zambia') }}</span>
                          </label>
                          <div class="task-group">
                            <label>
                              <input type="checkbox" id="child-task-1" />
                              <span>{{ t('locations.lusaka') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-2" />
                              <span>{{ t('locations.chingola') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-3" />
                              <span>{{ t('locations.kasama') }}</span>
                            </label>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div>
                          <label class="parent-check-box">
                            <input type="checkbox" id="parent-task" />
                            <span>{{ t('locations.mozambique') }}</span>
                          </label>
                          <div class="task-group">
                            <label>
                              <input type="checkbox" id="child-task-1" />
                              <span>{{ t('locations.maputo') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-2" />
                              <span>{{ t('locations.pemba') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-3" />
                              <span>{{ t('locations.nampula') }}</span>
                            </label>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="datelisting common-filter common-dropdown-checkbox">
                  <div class="common-drop-down dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-menu"
                      data-bs-toggle="dropdown" aria-expanded="false">
                      {{ t('filters.filterByDrivers') }}
                      <img src="assets/images-fuel/filterDrpDwnIcon.svg" alt="">
                    </button>

                    <ul class="dropdown-menu large-menu dropdown-menu-end checkbox-wrapper"
                      aria-labelledby="dropdown-menu" (click)="buttonMenuClick($event)">
                      <li>
                        <div class="dropdown-search drop-down-search">
                          <img src="assets/images-fuel/searchIcon.svg" alt="search-icon" />
                          <input type="text" [placeholder]="t('filters.searchAccounts')" />
                        </div>
                      </li>
                      <li>
                        <div>
                          <label class="parent-check-box">
                            <input type="checkbox" id="parent-task" />
                            <span>{{ t('locations.southAfrica') }}</span>
                          </label>
                          <div class="task-group">
                            <label>
                              <input type="checkbox" id="child-task-1" />
                              <span>{{ t('locations.johannesburg') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-2" />
                              <span>{{ t('locations.polokwane') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-3" />
                              <span>{{ t('locations.gqeberha') }}</span>
                            </label>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div>
                          <label class="parent-check-box">
                            <input type="checkbox" id="parent-task" />
                            <span>{{ t('locations.zambia') }}</span>
                          </label>
                          <div class="task-group">
                            <label>
                              <input type="checkbox" id="child-task-1" />
                              <span>{{ t('locations.lusaka') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-2" />
                              <span>{{ t('locations.chingola') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-3" />
                              <span>{{ t('locations.kasama') }}</span>
                            </label>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div>
                          <label class="parent-check-box">
                            <input type="checkbox" id="parent-task" />
                            <span>{{ t('locations.mozambique') }}</span>
                          </label>
                          <div class="task-group">
                            <label>
                              <input type="checkbox" id="child-task-1" />
                              <span>{{ t('locations.maputo') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-2" />
                              <span>{{ t('locations.pemba') }}</span>
                            </label>
                            <label>
                              <input type="checkbox" id="child-task-3" />
                              <span>{{ t('locations.nampula') }}</span>
                            </label>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="common-drop-down select-box dropdown">
                  <app-date-filter [filter]="utilizationDateFilter" [isButtonIntervalSelector]="false"
                    [disableCustomDateSelector]="false" [defaultInterval]="defaultInterval"
                    (filterChanged)="onUtilizationDateFilterChange($event)">
                  </app-date-filter>
                </div>
                <div class="button-wrapper">
                  <div class="common-drop-down no-filter dropdown">
                    <button type="button" id="dropdown-menu" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="grap-icon" />
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdown-menu">
                      <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                      <li>
                        <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                      </li>
                      <li>
                        <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                      </li>
                      <li>
                        <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                      </li>
                    </ul>
                  </div>
                  <button class="close-icon" (click)="closeModal()">
                    <img src="assets/images-fuel/crossBigIcon.svg" alt="icon-close" />
                  </button>
                </div>
              </div>
            </div>
            <div class="graph-down">
              <div class="line-chart">
                @defer (on timer(200ms)) {
                <app-multi-line-chart [data]="fuelCostChartData" [chartConfig]="fuelCostChartConfig" [yConfig]="yConfig"
                  [xConfig]="{ tickCount: 22 }" [margin]="{ top: 31, right: 10, bottom: 1, left: 32, height: 310 }"
                  [exportBtn]="true" />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>